var map = {
	"./bread.png": 5486,
	"./covered.png": 5978,
	"./cutlery.png": 5190,
	"./dessert.png": 4750,
	"./drinks.png": 3135,
	"./fish.png": 7600,
	"./meat.png": 611,
	"./salad.png": 2467,
	"./soup.png": 7763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 393;